import {
  AllowedCallTypes,
  makeApiStateSelectors
} from "seneca-common/utils/apiStates";

import { schoolInfoCrudStateConfig } from "../../../consts";

const {
  [AllowedCallTypes.FETCH]: {
    hasStarted: schoolInfoIsFetching,
    didSucceed: schoolInfoFetchSucceeded,
    didError: schoolInfoFetchErrored,
    hasFinished: schoolInfoFetchFinished,
    notSucceededOrStarted: schoolInfoNeedsFetching
  }
}: any = makeApiStateSelectors(schoolInfoCrudStateConfig);

export {
  schoolInfoIsFetching,
  schoolInfoFetchSucceeded,
  schoolInfoFetchErrored,
  schoolInfoFetchFinished,
  schoolInfoNeedsFetching
};
